import { useContext, useEffect, useState } from "react";
import { Button, Input, Label } from "reactstrap";

import "../../styles/ProjectAdmin.css"

import { RestContext } from "../../App";
import { ADMIN_URL, SITE_URL } from "../../serverConfig";
import MultiSelect from "../../components/MultiSelect";

function ProjectAdmin({}) {
    const [projectList, setProjectList] = useState([]);
    const [selectedProject, setSelectedProject] = useState(-1);
    const [siteList, setSiteList] = useState([]);
    const [projectName, setProjectName] = useState();
    const [projectAbbr, setProjectAbbr] = useState();
    const [managerName, setManagerName] = useState();
    const [managerEmail, setManagerEmail] = useState();
    const [managerPhone, setManagerPhone] = useState();
    const [selectedSites, setSelectedSites] = useState([]);

    const { sendGetRequest, sendPostRequest } = useContext(RestContext);

    useEffect(() => {
        loadProjects();
        sendGetRequest(SITE_URL + "/list", (response) => {
            const sites = response.data;
            for (let site of sites) {
                site.agencyName = site.agencyName || "Other";
            }
            setSiteList(sites);
        });
    }, []);

    useEffect(() => {
        if (selectedProject !== -1) {
            const project = projectList[selectedProject];
            setProjectName(project?.projectName || null);
            setProjectAbbr(project?.projectAbbr || null);
            setManagerName(project?.managerName || null);
            setManagerEmail(project?.managerEmail || null);
            setManagerPhone(project?.managerPhone || null);
            if (project?.sites) {
                const sites = [];
                for (let siteId of project.sites) {
                    const site = siteList.find((s) => s.siteId === siteId);
                    if (site) sites.push(site);
                }
                setSelectedSites(sites);
            } else {
                setSelectedSites([]);
            }
        }
    }, [selectedProject]);

    const loadProjects = () => {
        sendGetRequest(ADMIN_URL + "/projects", (response) => {
            setProjectList(response.data);
            if (response.data.length && selectedProject === -1) {
                setSelectedProject(0);
            }
        });
    }

    const mapProjectsToOption = () => {
        return projectList.map((project, index) => <option value={index}>{`${project.projectAbbr} - ${project.projectName}`}</option>)
    }

    const handleProject = (event) => {
        const { value } = event.target;
        setSelectedProject(value);
    }

    const handleProjectName = (event) => {
        const {value} = event.target;
        setProjectName(value);
    }

    const handleProjectAbbr = (event) => {
        const {value} = event.target;
        setProjectAbbr(value);
    }

    const handleManagerName = (event) => {
        const {value} = event.target;
        setManagerName(value);
    }

    const handleManagerEmail = (event) => {
        const {value} = event.target;
        setManagerEmail(value);
    }

    const handleManagerPhone = (event) => {
        const {value} = event.target;
        setManagerPhone(value);
    }

    const handleSubmit = () => {
        const siteIds = selectedSites.map(site => site.siteId);
        const payload = {
            projectId: projectList[selectedProject].projectId,
            projectName: projectName,
            projectAbbr: projectAbbr,
            managerName: managerName,
            managerEmail: managerEmail,
            managerPhone: managerPhone,
            sites: siteIds
        };
        sendPostRequest(ADMIN_URL + "/project", payload, (response) => {
            loadProjects();
        });
    }

    return (
        <div id="project-admin">
            <select id="project-admin-project-select" value={selectedProject} onChange={handleProject}>
                {mapProjectsToOption()}
            </select>
            <div id="project-admin-main">
                <div id="project-admin-left">
                    <Label for="projectName">Project Name:</Label>
                    <Input name="projectName" value={projectName} onChange={handleProjectName} />
                    <Label for="projectAbbr">Project Abbr:</Label>
                    <Input name="projectAbbr" value={projectAbbr} onChange={handleProjectAbbr} />
                    <Label for="managerName">Manager Name:</Label>
                    <Input name="managerName" value={managerName} onChange={handleManagerName} />
                    <Label for="managerEmail">Manager Email:</Label>
                    <Input name="managerEmail" value={managerEmail} onChange={handleManagerEmail} />
                    <Label for="managerPhone">Manager Phone:</Label>
                    <Input name="managerPhone" value={managerPhone} onChange={handleManagerPhone} />
                </div>
                <div id="project-admin-right">
                    <MultiSelect
                        className="project-admin-site-select"
                        data={siteList}
                        selected={selectedSites}
                        setSelected={setSelectedSites}
                        valField={"siteId"}
                        textField={"siteAbbr"}
                        groupField={"agencyName"}
                    />
                </div>
            </div>
            <Button className="submit-button" onClick={handleSubmit}>Save</Button>
        </div>
    )
}

export default ProjectAdmin;